import React, { useState } from 'react';
export const CANDLE_BEHAVIOR_DICT = {

  // =========================================================
  // ===================== TREND_UP ===========================
  // =========================================================

  PUMP: {
    short: 'PUMP',
    desc: 'Phe mua đẩy giá lên mạnh.',
    color: '#06b6d4',
    confidence: 'HIGH',
    mm_footprint: 'Market Maker (MM) chủ động rút lệnh Limit Sell ở các vùng kháng cự, tạo một khoảng trống thanh khoản phía trên để các lệnh Market Buy của đám đông tự quét sạch Orderbook. MM có thể "mồi" thêm vài lệnh Market Buy lớn ban đầu để kích hoạt các thuật toán mua đuổi (Algorithm Tracking) của các bên khác.',
    psychology: 'Tâm lý sợ bỏ lỡ cơ hội (FOMO) bao trùm toàn bộ thị trường. Những người lỡ tàu vội vã nhảy vào mua bất chấp giá, trong khi phe Short hoảng loạn cắt lỗ (bằng lệnh Market Buy), vô tình trở thành lực đẩy kép khiến giá bay thẳng đứng.',
    logic: 'Body lớn + Close near High'
  },

  STRONG_BULL: {
    short: 'S-BULL',
    desc: 'Buyer kiểm soát mạnh.',
    color: '#0ea5e9',
    confidence: 'HIGH',
    mm_footprint: 'Dòng tiền thông minh (Smart Money) đang liên tục bơm lệnh vào thị trường để duy trì xu hướng tăng. MM đặt các lệnh Limit Buy chặn dày đặc ở phía dưới để bảo vệ các mốc giá vừa chiếm lĩnh được, không cho giá điều chỉnh sâu.',
    psychology: 'Phe Mua đang cực kỳ tự tin và hưng phấn. Sự hoài nghi của phe Bán giảm dần, họ không dám nhảy vào cản tàu mà chọn cách đứng ngoài quan sát, khiến áp lực cung trên thị trường tạm thời biến mất.',
    logic: 'Body/Range cao'
  },

  WEAK_BULL: {
    short: 'W-BULL',
    desc: 'Đà tăng yếu.',
    color: '#38bdf8',
    confidence: 'HIGH',
    mm_footprint: 'Mặc dù giá đóng cửa vẫn tăng nhưng MM bắt đầu ngừng cung cấp thanh khoản mua (rút lệnh đỡ). Volume giao dịch giảm hoặc phân kỳ với giá, cho thấy MM đang kiểm tra xem lực cầu tự nhiên của nhỏ lẻ có còn mặn mà ở vùng giá cao này hay không.',
    psychology: 'Sự nghi ngờ xuất hiện ở cả hai phe. Phe Mua bắt đầu rén không dám đẩy tiếp vì sợ đu đỉnh, phe Bán thì rụt rè chưa dám short mạnh vì chưa thấy tín hiệu đảo chiều rõ ràng. Thị trường rơi vào trạng thái lưỡng lự.',
    logic: 'Body nhỏ nhưng vẫn bullish'
  },

  MARUBOZU_BULL: {
    short: 'MBULL',
    desc: 'Bullish cực mạnh gần như không có râu.',
    color: '#0284c7',
    confidence: 'VERY_HIGH',
    mm_footprint: 'Sự thao túng tập trung tuyệt đối (Absolute Monopolization). MM và các quỹ lớn cùng đồng thuận đẩy giá lên một mạch từ lúc mở cửa đến lúc đóng cửa. Không có bất kỳ nhịp điều chỉnh hay sự từ chối giá nào được phép xảy ra trong suốt khung giờ.',
    psychology: 'Tâm lý quy phục hoàn toàn. Phe Bán bị tiêu diệt hoặc đầu hàng hoàn toàn, không một ai dám đặt lệnh ngược chiều. Thị trường rơi vào trạng thái tăng giá cực đoan và có độ tin cậy tiếp diễn xu hướng rất cao.',
    logic: 'Full body candle'
  },

  // =========================================================
  // ==================== TREND_DOWN =========================
  // =========================================================

  DUMP: {
    short: 'DUMP',
    desc: 'Phe bán đẩy giá xuống mạnh.',
    color: '#ef4444',
    confidence: 'HIGH',
    mm_footprint: 'MM chủ động kích hoạt các lệnh Market Sell quy mô lớn để đánh sập các tường mua Limit bên dưới. Mục tiêu là tạo ra một cú sốc giảm giá nhanh nhằm kích hoạt chuỗi thanh lý tự động (Cascading Liquidations) của các lệnh Long.',
    psychology: 'Tâm lý hoảng loạn tột độ (Panic Selling). Đám đông bị bất ngờ, nỗi sợ hãi lấn át lý trí khiến họ giẫm đạp lên nhau để thoát hàng bằng lệnh Market, đẩy giá rơi tự do đúng ý đồ ép giá của MM.',
    logic: 'Body lớn + Close near Low'
  },

  STRONG_BEAR: {
    short: 'S-BEAR',
    desc: 'Seller kiểm soát mạnh.',
    color: '#dc2626',
    confidence: 'HIGH',
    mm_footprint: 'Áp lực bán tháo diễn ra liên tục và có tổ chức. MM rút toàn bộ tường đỡ Limit Buy ở phía dưới và liên tục dời tường bán Limit Sell xuống thấp hơn để đè giá, không cho thị trường bất kỳ một cơ hội hồi phục nào.',
    psychology: 'Bi quan tràn ngập. Phe Mua hoàn toàn buông xuôi và rút lui khỏi thị trường, trong khi phe Bán hăng máu liên tục nhồi thêm vị thế vì tin rằng đáy còn rất xa.',
    logic: 'Body/Range cao'
  },

  WEAK_BEAR: {
    short: 'W-BEAR',
    desc: 'Đà giảm yếu.',
    color: '#f87171',
    confidence: 'HIGH',
    mm_footprint: 'Giá vẫn giảm nhưng tốc độ giảm đã chậm lại rõ rệt. MM bắt đầu rải các lệnh Limit Buy ẩn (Iceberg) để gom hàng nhẹ nhàng tại các vùng giá thấp, khiến phe Bán dù cố xả nhưng giá không thể giảm sâu thêm được nữa.',
    psychology: 'Lực bán đã chớm cạn kiệt (Sellers Exhaustion). Phe Bán bắt đầu chốt lời vị thế Short, phe Mua nhen nhóm ý định bắt đáy nhưng vẫn còn e dè do dư chấn của cú sập trước đó.',
    logic: 'Body nhỏ nhưng vẫn bearish'
  },

  MARUBOZU_BEAR: {
    short: 'MBEAR',
    desc: 'Bearish cực mạnh gần như không có râu.',
    color: '#991b1b',
    confidence: 'VERY_HIGH',
    mm_footprint: 'Hành vi "xả lũ" chốt lời hoặc dìm chết dự án một cách tàn nhẫn của MM. Lệnh bán Market ép thẳng từ đỉnh xuống đáy cây nến, ép phe Long phải gồng lỗ trong tuyệt vọng mà không cho một nhịp hồi kỹ thuật nào để thoát hàng.',
    psychology: 'Tuyệt vọng hoàn toàn (Capitulation). Trader nhỏ lẻ cắt lỗ hàng loạt đúng đáy nến hoặc bị sàn thanh lý cưỡng bức. Thị trường bị bao phủ bởi màu đỏ chết chóc và không có dấu hiệu của lực đỡ.',
    logic: 'Full body candle'
  },

  // =========================================================
  // ================= REJECTION_UPPER =======================
  // =========================================================

  SHOOTING_STAR: {
    short: 'STAR-H',
    desc: 'Reject mạnh phía trên.',
    color: '#fb7185',
    confidence: 'VERY_HIGH',
    mm_footprint: 'Đây là cái bẫy tinh vi nhất của MM (Bull Trap). MM cố tình đẩy giá vượt đỉnh hoặc kháng cự để dụ toàn bộ dòng tiền FOMO Buy nhảy vào, sau đó họ tung ra một lượng lệnh Limit Sell khổng lồ chặn đứng đà tăng và ép giá sập ngược trở lại.',
    psychology: 'Phe Mua chuyển từ trạng thái cực kỳ hưng phấn sang ngỡ ngàng và đau đớn khi nhận ra mình vừa đu đúng đỉnh râu nến. Tâm lý hoang mang tột độ xuất hiện và thường dẫn đến việc bán tháo cắt lỗ ngay sau đó.',
    logic: 'Upper wick >> Body'
  },

  UPPER_REJECTION: {
    short: 'UP-REJ',
    desc: 'Bị từ chối vùng giá phía trên.',
    color: '#f43f5e',
    confidence: 'HIGH',
    mm_footprint: 'Khi giá tiến vào vùng cung mạnh, MM phát hiện lượng lệnh Limit Sell của các tay chơi lớn đang chờ sẵn quá nhiều. MM quyết định dừng cuộc chơi đánh lên, rút lệnh mua và để áp lực cung tự nhiên đè bẹp lực cầu.',
    psychology: 'Phe Mua bắt đầu nhận ra vùng giá phía trên là "vùng cấm" khó có thể vượt qua trong ngắn hạn. Lực mua chùn bước, trader chủ động chốt lời các vị thế Long khiến giá quay đầu tạo râu.',
    logic: 'Upper wick lớn'
  },

  // =========================================================
  // ================= REJECTION_LOWER =======================
  // =========================================================

  HAMMER: {
    short: 'HAMMER',
    desc: 'Reject mạnh phía dưới.',
    color: '#4ade80',
    confidence: 'VERY_HIGH',
    mm_footprint: 'Chiến dịch săn thanh khoản (Bear Trap / Stop-run). MM giật giá xuống thật sâu dưới hỗ trợ để quét sạch lệnh dừng lỗ của phe Long, đồng thời dụ phe Short nhảy vào. Tại đáy, MM kích hoạt toàn bộ lệnh Limit Buy khổng lồ để nuốt sạch hàng và kéo giá lên thần tốc.',
    psychology: 'Phe Short bị sập bẫy ngỡ ngàng khi vừa bán xong thì giá rút chân bay thẳng đứng. Phe Long bị quét mất hàng trong tiếc nuối. Tâm lý thị trường đảo chiều 180 độ sang trạng thái muốn bắt đáy.',
    logic: 'Lower wick >> Body'
  },

  LOWER_REJECTION: {
    short: 'LOW-REJ',
    desc: 'Bị từ chối vùng giá phía dưới.',
    color: '#22c55e',
    confidence: 'HIGH',
    mm_footprint: 'Giá chạm vào vùng cầu tiềm năng và MM nhận thấy dòng tiền bắt đáy của cá voi đang trực chờ. MM không dại gì bán lỗ tiếp, họ ngừng xả Market và chuyển sang thế trận gom hàng phối hợp cùng lực mua tự nhiên.',
    psychology: 'Phe Bán hoài nghi về khả năng giảm tiếp của thị trường khi thấy giá liên tục bị đẩy ngược lên mỗi khi giảm sâu. Phe Mua tự tin hơn và bắt đầu rải lệnh giải ngân.',
    logic: 'Lower wick lớn'
  },

  // =========================================================
  // ===================== BALANCED ==========================
  // =========================================================

  BALANCED: {
    short: 'BALNC',
    desc: 'Không phe nào kiểm soát rõ.',
    color: '#64748b',
    confidence: 'HIGH',
    mm_footprint: 'MM đang thực hiện chiến lược cân bằng sổ lệnh (Order Book Balancing). Họ đặt lệnh mua và bán đối ứng bằng nhau ở cả hai đầu nhằm giữ giá ổn định trong một phạm vi hẹp để tích lũy hoặc phân phối nhỏ giọt.',
    psychology: 'Thị trường rơi vào trạng thái vô hướng, không có tin tức vĩ mô bổ trợ. Trader nhỏ lẻ đứng ngoài ôm tiền mặt hoặc chỉ giao dịch lướt sóng cực ngắn với khối lượng nhỏ vì sợ đi sai hướng.',
    logic: 'Body trung tính'
  },

  SIDEWAY: {
    short: 'SIDE',
    desc: 'Đi ngang thiếu động lượng.',
    color: '#475569',
    confidence: 'HIGH',
    mm_footprint: 'Thanh khoản cạn kiệt có chủ đích. MM rút bớt các robot giao dịch tự động (Market Making Bots) làm cho sổ lệnh trở nên rất mỏng. Giá dao động dật dờ trong biên độ hẹp mà không có dòng tiền lớn dẫn dắt.',
    psychology: 'Tâm lý chán nản và mệt mỏi cùng cực. Khối lượng giao dịch sụt giảm nghiêm trọng, trader mất kiên nhẫn dễ rời bỏ thị trường hoặc chuyển sang chú ý các cặp tiền khác sôi động hơn.',
    logic: 'Range nhỏ'
  },

  SPINNING_TOP: {
    short: 'SPIN',
    desc: 'Do dự mạnh với wick hai đầu.',
    color: '#94a3b8',
    confidence: 'VERY_HIGH',
    mm_footprint: 'Trận chiến ác liệt nhưng không phân thắng bại. MM thả cho hai phe tự do va chạm dữ dội, giá bị đẩy lên cao rồi lại dập xuống sâu nhưng cuối cùng quay về đóng cửa ở giữa nến, cho thấy cung cầu đang tạm thời bão hòa.',
    psychology: 'Sự giằng xé tâm lý dữ dội của đám đông. Cả phe Mua và phe Bán đều cố gắng bứt phá nhưng đều bị phản đòn đau đớn. Sự hoang mang về xu hướng tiếp theo đạt mức tối đa.',
    logic: 'Body nhỏ + Wick 2 đầu'
  },

  INSIDE_BAR: {
    short: 'INSIDE',
    desc: 'Nến nằm hoàn toàn trong nến trước.',
    color: '#64748b',
    confidence: 'VERY_HIGH',
    mm_footprint: 'MM đang chủ động bóp nghẹt biên độ giao dịch để tạo mô hình nén (Bracketing). Giá không thể phá đỉnh cũng không thể thủng đáy của nến trước, chứng tỏ MM đang thiết lập một vùng tích trữ năng lượng cực lớn.',
    psychology: 'Tâm lý nín thở chờ đợi (Wait-and-See). Trader chuyên nghiệp ngừng vào lệnh mới và chuyển sang đặt các lệnh chờ Breakout ở hai đầu cây nến mẹ (Mother Bar) vì họ biết một cơn bão sắp quét qua.',
    logic: 'Inside previous candle'
  },

  // =========================================================
  // ===================== VOLATILE ==========================
  // =========================================================

  HIGH_VOLATILITY: {
    short: 'H-VOL',
    desc: 'Biến động mạnh.',
    color: '#8b5cf6',
    confidence: 'VERY_HIGH',
    mm_footprint: 'MM đang thực hiện việc mở rộng biên độ quét (Spread Expansion). Họ nới lỏng khoảng cách giữa giá Ask và Bid trong Orderbook để các lệnh Market của đám đông tự va đập và tạo ra những cây nến có râu hoặc thân giật liên tục.',
    psychology: 'Tâm lý phấn khích đi kèm hoảng sợ. Các lệnh Margin/Futures đòn bẩy cao bị quét thanh lý liên tục ở cả hai đầu, tài khoản của nhỏ lẻ biến động mạnh khiến họ dễ đưa ra các quyết định sai lầm.',
    logic: 'Range tăng mạnh'
  },

  WIDE_RANGE_CANDLE: {
    short: 'W-RNG',
    desc: 'Nến có biên độ rất lớn.',
    color: '#7c3aed',
    confidence: 'VERY_HIGH',
    mm_footprint: 'Cá voi khổng lồ hoặc các định chế tài chính lớn chính thức ra tay. MM buộc phải nhường sân và khớp các lệnh lớn này, tạo ra một cây nến có độ dài vượt trội hoàn toàn so với trung bình 20 cây nến trước đó.',
    psychology: 'Thị trường bị sốc nặng. Đám đông ngỡ ngàng trước xung lực quá mạnh của nến và thường xu hướng này sẽ định hình hướng đi cho cả vài ngày hoặc vài tuần tới.',
    logic: 'Range >> Average range'
  },

  VOLATILE_BALANCE: {
    short: 'V-BAL',
    desc: 'Biến động lớn nhưng thiếu hướng đi rõ.',
    color: '#9333ea',
    confidence: 'VERY_HIGH',
    mm_footprint: 'Chiến dịch "Thảm sát hai đầu" (Dual Liquidation). MM giật giá lên đỉnh để giết phe Short, rồi lập tức đạp giá xuống đáy để giết phe Long trong cùng một khung giờ. Thân nến nhỏ nhưng tổng range quét cực kỳ kinh khủng.',
    psychology: 'Trader bị loạn nhịp hoàn toàn. Đánh lên cũng chết, đánh xuống cũng chết, dẫn đến trạng thái hoang mang, mất phương hướng và hoài nghi vào mọi hệ thống phân tích kỹ thuật.',
    logic: 'Large range + Small body'
  },

  COMPRESSION_PHASE: {
    short: 'COMP',
    desc: 'Volatility co hẹp dần.',
    color: '#c084fc',
    confidence: 'HIGH',
    mm_footprint: 'Hành vi nén lò xo (Volatility Squeeze). MM dùng các thuật toán tinh vi để ép giá đóng cửa và biên độ dao động nhỏ dần đều qua từng cây nến. Mục đích là làm sạch hoàn toàn những trader lướt sóng ngắn hạn ra khỏi thị trường.',
    psychology: 'Áp lực tâm lý bị dồn nén. Thị trường trở nên cực kỳ im ắng và tù túng, tạo cảm giác ngột ngạt cho các trader đang ôm lệnh vị thế lớn.',
    logic: 'Range shrink liên tục'
  },

  EXPANSION_MOVE: {
    short: 'EXPAND',
    desc: 'Volatility mở rộng mạnh.',
    color: '#8b5cf6',
    confidence: 'HIGH',
    mm_footprint: 'Lò xo bị nén chính thức bung ra. MM tung lệnh Market kích nổ trực tiếp vào vùng tích lũy, phá vỡ thế cân bằng và ép dải băng biến động mở rộng sang hai bên một cách quyết liệt.',
    psychology: 'Sự bùng nổ cảm xúc. Đám đông thức tỉnh sau chuỗi ngày ảm đạm, vội vã lao vào thị trường theo hướng bứt phá, tạo ra một lượng volume khổng lồ trong thời gian ngắn.',
    logic: 'Range expansion liên tục'
  },

  // =========================================================
  // ===================== BREAKOUT ==========================
  // =========================================================

  CLEAN_BREAKOUT_UP: {
    short: 'BO-UP',
    desc: 'Breakout tăng rõ ràng.',
    color: '#06b6d4',
    confidence: 'HIGH',
    mm_footprint: 'MM chủ động phá vỡ bức tường Limit Sell tại vùng kháng cự cứng. Họ không chỉ khớp hết lệnh bán ở đó mà còn đẩy giá đóng cửa nằm hẳn phía trên vùng kháng cự để xác nhận một xu hướng tăng trưởng mới.',
    psychology: 'Tâm lý giải tỏa và hưng phấn cực độ. Phe Mua giành chiến thắng toàn diện, các trader theo trường phái Breakout (Breakout Traders) đồng loạt kích hoạt lệnh mua đuổi làm động lực tăng giá càng mạnh.',
    logic: 'Close vượt resistance'
  },

  CLEAN_BREAKOUT_DOWN: {
    short: 'BO-DN',
    desc: 'Breakout giảm rõ ràng.',
    color: '#ef4444',
    confidence: 'HIGH',
    mm_footprint: 'MM đập tan tường đỡ Limit Buy tại hỗ trợ then chốt. Họ ép giá đóng cửa nằm sâu dưới mốc này nhằm tuyên bố xu hướng giảm chính thức bắt đầu và chặn đứng mọi hy vọng hồi phục của phe bò.',
    psychology: 'Tâm lý sụp đổ niềm tin. Toàn bộ phe giữ lệnh Long chấp nhận sự thật là mình đã sai, họ đồng loạt bấm nút bán cắt lỗ, kết hợp với phe Short bồi thêm lệnh khiến thị trường chìm trong hoảng loạn.',
    logic: 'Close phá support'
  },

  // =========================================================
  // ===================== EXHAUSTED =========================
  // =========================================================

  EXHAUSTED: {
    short: 'EXHST',
    desc: 'Mất động lượng.',
    color: '#84cc16',
    confidence: 'HIGH',
    mm_footprint: 'Sự kiệt quệ tự nhiên (Natural Exhaustion). MM hoàn toàn rút lui, để mặc thị trường tự vận hành. Cả khối lượng giao dịch lẫn biên độ giá đều sụt giảm nghiêm trọng do không còn dòng tiền lớn mặn mà ở xu hướng hiện tại.',
    psychology: 'Phe đang dẫn đầu xu hướng đã cạn kiệt năng lượng sau một quãng đường dài đẩy giá, phe đối lập thì không còn vốn để phản công. Thị trường rơi vào trạng thái ngủ đông lâm thời.',
    logic: 'Small spread + Small body'
  },

  DOJI: {
    short: 'DOJI',
    desc: 'Do dự cực mạnh.',
    color: '#a3e635',
    confidence: 'VERY_HIGH',
    mm_footprint: 'Trạng thái ngưng kết thanh khoản (Liquidity Freeze). Giá mở cửa và đóng cửa gần như trùng khít lên nhau, cho thấy MM đã thiết lập một vùng cân bằng toán học tuyệt đối giữa hai đầu sổ lệnh, không cho bất kỳ bên nào lệch sóng dù chỉ 1 pip.',
    psychology: 'Tâm lý đứng hình trước ngã ba đường. Toàn bộ thị trường nín thở chờ đợi một tin tức vĩ mô hoặc một cú hích từ cá voi để định hình xu hướng mới. Đây là chỉ báo báo hiệu một bước ngoặt đảo chiều rất gần.',
    logic: 'Open gần bằng Close'
  }
};

export default function CandleAnalyzer({ selectedCandle }) {
  // Trạng thái đóng/mở cho phần giải thích chuyên sâu
  const [showDeepInsight, setShowDeepInsight] = useState(false);

  // 1. Kiểm tra an toàn đầu vào (Tránh lỗi Crash khi selectedCandle chưa tồn tại hoặc bằng null)
  if (!selectedCandle || !selectedCandle.details) {
    return (
      <div style={{ 
        color: '#94a3b8', 
        padding: '30px', 
        textAlign: 'center', 
        background: '#0f172a', 
        borderRadius: '12px',
        border: '1px dashed #334155' 
      }}>
        <div style={{ fontSize: '24px', marginBottom: '8px' }}>🔍</div>
        <div>Vui lòng chọn một ô nến trên ma trận để giải phẫu dòng tiền...</div>
      </div>
    );
  }

  // Khớp dữ liệu trạng thái từ nến đang soi với từ điển hành vi
  const stateKey = selectedCandle.state || 'BALANCED';
  const info = CANDLE_BEHAVIOR_DICT[stateKey] || {
    short: 'N/A',
    desc: 'Trạng thái hệ thống chưa được phân loại chi tiết hành vi.',
    color: '#64748b',
    confidence: 'LOW',
    mm_footprint: 'Không có dữ liệu dấu chân Market Maker cho trường hợp này.',
    psychology: 'Không có phân tích tâm lý đám đông cụ thể.',
    logic: 'Chưa định nghĩa'
  };

  // Hàm xác định màu sắc hiển thị cho mức độ tin cậy (Confidence Meter)
  const getConfidenceColor = (level) => {
    if (level === 'VERY_HIGH') return '#22c55e'; // Xanh lá
    if (level === 'HIGH') return '#eab308';      // Vàng
    return '#ef4444';                             // Đỏ
  };

  // 2. Ép kiểu dữ liệu an toàn để tránh crash khi tính toán CSS width
  const takerBuyPct = parseFloat(selectedCandle.details.takerBuy) || 50;
  const takerSellPct = parseFloat(selectedCandle.details.takerSell) || 50;

  return (
    <div style={{ 
      background: '#0f172a', 
      borderRadius: '12px', 
      border: `1px solid ${info.color}40`, 
      padding: '20px',
      color: '#f1f5f9',
      fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)'
    }}>
      
      {/* HEADER SECTION: Tên Trạng thái & Định danh định lượng */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '1px solid #1e293b', paddingBottom: '15px', marginBottom: '15px' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '50%', backgroundColor: info.color }} />
            <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', letterSpacing: '0.5px', color: info.color }}>
              {stateKey.replace(/_/g, ' ')} ({info.short})
            </h2>
          </div>
          <div style={{ fontSize: '11px', color: '#ffffff', marginTop: '4px', fontFamily: 'monospace' }}>
            ID: {selectedCandle.id || 'N/A'} | KHUNG: {selectedCandle.interval || 'N/A'}
          </div>
        </div>

        {/* Cột mốc thời gian thực tế */}
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '12px', fontWeight: '600', color: '#ffffff' }}>{selectedCandle.time || 'N/A'}</div>
          <div style={{ fontSize: '10px', color: '#ffffff', marginTop: '2px' }}>{selectedCandle.realTime || 'N/A'}</div>
        </div>
      </div>

      {/* METRICS GRID: Hiển thị toàn bộ các số liệu tính toán chi tiết từ sàn */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px', marginBottom: '15px' }}>
        
        {/* Khối biên độ & cấu trúc hình học của nến */}
        <div style={{ background: '#1e293b60', padding: '12px', borderRadius: '8px', border: '1px solid #1e293b' }}>
          <div style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '600' }}>BIẾN ĐỘNG GIÁ & HÌNH THÁI</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
            <span style={{ fontSize: '12px', color: '#cbd5e1' }}>Hiệu suất (Spread):</span>
            <span style={{ fontSize: '13px', fontWeight: 'bold', color: selectedCandle.isGreen ? '#22c55e' : '#ef4444' }}>
              {selectedCandle.spreadStr || '0.00%'}
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
            <span style={{ fontSize: '12px', color: '#cbd5e1' }}>Biên độ quét (Range):</span>
            <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#e2e8f0' }}>{selectedCandle.details.rangePct || '0.000'}%</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
            <span style={{ fontSize: '12px', color: '#cbd5e1' }}>Hình thái râu nến:</span>
            <span style={{ fontSize: '12px', fontWeight: '600', color: '#38bdf8' }}>{selectedCandle.details.wick || 'Bình thường'}</span>
          </div>
        </div>

        {/* Khối dữ liệu về mật độ giao dịch & khối lượng tiền mặt */}
        <div style={{ background: '#1e293b60', padding: '12px', borderRadius: '8px', border: '1px solid #1e293b' }}>
          <div style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '600' }}>MẬT ĐỘ DÒNG TIỀN TRÊN MỖI LỆNH</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
            <span style={{ fontSize: '12px', color: '#cbd5e1' }}>Tổng số lệnh (Trades):</span>
            <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#f1f5f9' }}>
              {selectedCandle.details.trades ? selectedCandle.details.trades.toLocaleString() : 0}
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
            <span style={{ fontSize: '12px', color: '#22c55e' }}>Mua CĐ/Lệnh (Avg):</span>
            <span style={{ fontSize: '12px', fontWeight: '600', color: '#22c55e' }}>{selectedCandle.details.avgBuy || '0'} Coin</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
            <span style={{ fontSize: '12px', color: '#ef4444' }}>Bán CĐ/Lệnh (Avg):</span>
            <span style={{ fontSize: '12px', fontWeight: '600', color: '#ef4444' }}>{selectedCandle.details.avgSell || '0'} Coin</span>
          </div>
        </div>
      </div>

      {/* TAKER VOLUME POWER BAR: Biểu đồ thanh ngang so sánh tương quan lực Mua/Bán */}
      <div style={{ marginBottom: '18px', background: '#1e293b60', padding: '12px', borderRadius: '8px', border: '1px solid #1e293b' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', color: '#94a3b8', fontWeight: '600', marginBottom: '6px' }}>
          <span>PHE MUA CHỦ ĐỘNG (TAKER BUY)</span>
          <span>PHE BÁN CHỦ ĐỘNG (TAKER SELL)</span>
        </div>
        
        {/* Thanh lực phân bổ phần trăm - ĐÃ SỬA LỖI TYPO CRASH TẠI ĐÂY */}
        <div style={{ display: 'flex', width: '100%', height: '8px', borderRadius: '4px', overflow: 'hidden', background: '#334155', marginBottom: '6px' }}>
          <div style={{ width: `${takerBuyPct}%`, backgroundColor: '#22c55e', transition: 'width 0.3s ease' }} />
          <div style={{ width: `${takerSellPct}%`, backgroundColor: '#ef4444', transition: 'width 0.3s ease' }} />
        </div>

        {/* Con số chi tiết về mặt số lượng tiền mặt quy đổi (USDT) */}
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', fontWeight: 'bold' }}>
          <span style={{ color: '#22c55e' }}>{takerBuyPct}% <span style={{ fontWeight: 'normal', fontSize: '10px', color: '#ffffff' }}>({selectedCandle.details.avgBuyQuote || 0} USDT/Trd)</span></span>
          <span style={{ color: '#ef4444' }}>{takerSellPct}% <span style={{ fontWeight: 'normal', fontSize: '10px', color: '#ffffff' }}>({selectedCandle.details.avgSellQuote || 0} USDT/Trd)</span></span>
        </div>
      </div>

      {/* BEHAVIOR BASE DESCRIPTION: Bản chất cốt lõi thu gọn */}
      <div style={{ background: 'rgba(255,255,255,0.02)', padding: '12px', borderRadius: '8px', borderLeft: `4px solid ${info.color}`, marginBottom: '15px' }}>
        <div style={{ fontSize: '11px', color: '#94a3b8', fontWeight: 'bold' }}>ĐÁNH GIÁ SƠ BỘ SỰ KIỆN</div>
        <div style={{ fontSize: '14px', marginTop: '4px', lineHeight: '1.4', color: '#e2e8f0' }}>{info.desc}</div>
      </div>

      {/* ACCORDION TRIGGER BUTTON: Nút nhấn để kích hoạt hiển thị hồ sơ chuyên sâu */}
      <button 
        type="button"
        onClick={() => setShowDeepInsight(!showDeepInsight)}
        style={{
          width: '100%',
          padding: '10px',
          background: showDeepInsight ? '#1e293b' : 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
          border: '1px solid #334155',
          borderRadius: '6px',
          color: '#38bdf8',
          fontSize: '12px',
          fontWeight: 'bold',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '6px',
          transition: 'all 0.2s ease',
          outline: 'none'
        }}
      >
        <span>{showDeepInsight ? '🔼 ĐÓNG BẢN PHÂN TÍCH CHUYÊN SÂU' : '🔽 XEM BẢN PHÂN TÍCH CHUYÊN SÂU (MM & TÂM LÝ)'}</span>
      </button>

      {/* ACCORDION CONTENT PANEL: Hồ sơ giải phẫu chi tiết tâm lý & thuật toán MM */}
      {showDeepInsight && (
        <div style={{ 
          marginTop: '15px', 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '12px'
        }}>
          
          {/* Box Dấu chân Thao túng của Market Maker */}
          <div style={{ background: '#111827', padding: '14px', borderRadius: '8px', border: '1px solid #1e293b' }}>
            <div style={{ color: info.color, fontSize: '11px', fontWeight: 'bold', marginBottom: '6px', letterSpacing: '0.5px' }}>
              🔍 DẤU CHÂN THAO TÚNG CỦA MARKET MAKER (MM FOOTPRINT)
            </div>
            <div style={{ color: '#cbd5e1', fontSize: '13px', lineHeight: '1.5', textAlign: 'justify' }}>
              {info.mm_footprint}
            </div>
          </div>

          {/* Box Đọc vị diễn biến Tâm lý Đám đông thực tế */}
          <div style={{ background: '#111827', padding: '14px', borderRadius: '8px', border: '1px solid #1e293b' }}>
            <div style={{ color: '#f43f5e', fontSize: '11px', fontWeight: 'bold', marginBottom: '6px', letterSpacing: '0.5px' }}>
              🧠 TÂM LÝ ĐÀM ĐÔNG & HỆ QUẢ HÀNH VI (MARKET PSYCHOLOGY)
            </div>
            <div style={{ color: '#cbd5e1', fontSize: '13px', lineHeight: '1.5', textAlign: 'justify' }}>
              {info.psychology}
            </div>
          </div>

          {/* Khối chân trang chứa điều kiện kích hoạt hệ thống & Trọng số của tín hiệu */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            background: '#1e293b40', 
            padding: '10px 14px', 
            borderRadius: '8px',
            fontSize: '11px'
          }}>
            <div style={{ fontFamily: 'monospace', color: '#60a5fa' }}>
              <span style={{ color: '#94a3b8' }}>Mô hình Logic:</span> {info.logic}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ color: '#94a3b8' }}>Độ tin cậy:</span>
              <span style={{ 
                color: getConfidenceColor(info.confidence), 
                fontWeight: 'bold',
                background: `${getConfidenceColor(info.confidence)}15`,
                padding: '2px 6px',
                borderRadius: '4px',
                border: `1px solid ${getConfidenceColor(info.confidence)}30`
              }}>
                {info.confidence}
              </span>
            </div>
          </div>

        </div>
      )}

    </div>
  );
}
